import { createStrings } from '@utils/local';

export const userStrings = createStrings({
  ja: {
    email: 'メール',
    emailDuplicate: 'このメールアドレスはすでに登録されています。他のアドレスをお試しください。',
    notSamePassword2: 'パスワードは一致しません。',
    password1: 'パスワード',
    password2: 'パスワード再入力',
    last_name: '姓',
    first_name: '名',
    cellphone: '携帯電話番号',
    company_name: '会社名',
  },
});
